import { render, staticRenderFns } from "./CompetitorWarning.vue?vue&type=template&id=34a00d3e&scoped=true&"
import script from "./CompetitorWarning.vue?vue&type=script&lang=ts&"
export * from "./CompetitorWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a00d3e",
  null
  
)

export default component.exports